<template>
  <div id="page-selects">
    <v-container grid-list-xl fluid>
      <breadcrumbs
        :routelinks="[
          { text: 'Policy', href: '#/policies' },
          { text: 'Assigning Policy', href: '#', disabled: true }
        ]"
      />
      <v-layout row wrap>
        <v-flex lg12 md12 xs12>
          <v-card class="pa-3">
            <v-input info>{{ policy.policy }}</v-input>
            <v-select
              :items="companies"
              v-model="currentCompany.company"
              label="Company"
              item-text="company_name"
              item-value="company_id"
              single-line
              @change="changeCompany(currentCompany.company)"
            ></v-select>
            <v-select
              :items="activeTypes"
              v-model="currentCompany.active_types"
              label="Assign To "
              item-text="title"
              item-value="value"
              multiple
            ></v-select>
            <v-text-field
              label="Policy URL"
              v-model="currentCompany.policy_link"
            ></v-text-field>
            <div style="text-align: right;">
              <v-btn color="info" small type="submit" @click="assignPolicy"
                >Submit</v-btn
              >
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import APIPolicies from "@/mixins/APIPolicies";
import APICompany from "@/mixins/APICompany";

import Breadcrumbs from "@/components/Breadcrumbs";
export default {
  mixins: [APIPolicies, APICompany],
  components: {
    Breadcrumbs
  },
  data() {
    return {
      policy: {},
      currentCompany: {},
      activeTypes: [
        // {
        //   title: "Student",
        //   value: "1"
        // },
        // {
        //   title: "Staff",
        //   value: "2"
        // },
        {
          title: "Visitor",
          value: "3"
        },
        {
          title: "Contractor",
          value: "4"
        }
      ],
      types: [],
      companies: [],
      email: "",
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  created() {
    if (this.$route.params.policy) {
      this.policy = this.$route.params.policy;
    }

    this.handleGetCompany();
  },
  computed: {},
  watch: {},
  methods: {
    handleGetCompany: async function() {
      try {
        this.companies = await this.getCompanies();
      } catch (error) {
        
      }
    },
    changeCompany: function(id) {
      let val = this.companies
        .filter(obj => {
          return obj.company_id === id;
        })
        .map(obj => {
          return obj;
        });

      this.currentCompany.url = val[0].url;
      this.currentCompany.port = val[0].port;
    },
    assignPolicy: async function() {
      this.currentCompany.policy = this.policy.policy;
      try {
        if (this.currentCompany._id) {
          await this.putContractor(this.currentCompany);
        } else {
          let responce = await this.postAssigning(this.currentCompany);
          
          
          this.$store.commit("setStudentSwitchState", {
            action: null,
            payload: responce
          });
        }
        this.$toast.success("Success", "submitted", { position: "topCenter" });
      } catch (error) {
        this.$toast.error("Failed to submit details", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>
